import { apiClient } from '@/shared/api/client'

export async function getAdminDashboard(params = {}) {
  const response = await apiClient.get('/admin/dashboard', {
    params: { ...params, _t: Date.now() },
  })

  return response.data
}
